import { useQuery } from "@tanstack/react-query";
import type { FeatureKey } from "@school-sales-ai/shared";
import { listClientFeaturesApi } from "@/lib/api";
import { useClientSwitcherStore } from "@/stores/client-switcher.store";

// Feature keys granted by the active client's plan — the CRM gates modules on
// these (e.g. Visitas requires "visits"). Keyed on the active client so it
// refetches when a super-admin/account-manager switches schools. The backend
// resolves the client from the X-Client-Id header (attached by api.ts).
export function useClientFeatures() {
  const activeClientId = useClientSwitcherStore((s) => s.activeClientId);
  return useQuery({
    queryKey: ["crm", "features", activeClientId],
    queryFn: listClientFeaturesApi,
    staleTime: 60_000,
  });
}

// One feature as a boolean, for a component deep in a tree (a board card) that
// would otherwise need the flag drilled through three levels. False while the
// list loads: a gate renders LESS until it knows.
export function useHasClientFeature(key: FeatureKey): boolean {
  const { data } = useClientFeatures();
  return (data ?? []).includes(key);
}
